import Axios from 'axios'
import {getCookie} from '../../utils/common';

export const getOptionBookList = async (symbol, onDate) => {
  const apiUrl = getCookie('apiUrl') || 'https://api.optionsedu.com/graphql'
  const query: Object = {
    query: `
        query {
          securities {
            options {
              optionBook(symbol: "${symbol}" ${onDate ? `, onDate: "${onDate}"` : ''}) {
                symbol
                price
                series {
                  expiration
                  asStraddles {
                    call_Symbol
                    call_Ask
                    call_Bid
                    call_OpenInterest
                    call_Volume
                    underlyingPrice
                    multiplier
                    underlyingSymbol
                    strike
                    expiration
                    put_Symbol
                    put_Ask
                    put_Bid
                    put_OpenInterest
                    put_Volume
                    quoteInterval
                    sampleTime
                    securityType
                    style
                    delay
                    multiplier
                    onDate
                  }
                }
              }
            }
          }
        }
      `
  }

  const CONTENT_TYPE = { 'Content-Type': 'application/x-www-form-urlencoded' }

  return await Axios.post(apiUrl, query, { headers: CONTENT_TYPE }).catch(err=>{
    return err;
  })
}


// WEBPACK FOOTER //
// ./src/actions/optionbook/index.js